// Import the necessary components
import VerofreshRecord from './VerofreshRecord'

class ProductRecord extends VerofreshRecord {
  static get ZONE_FREEZER () { return 'freezer' }
  static get ZONE_COOLER () { return 'cooler' }
  static get ZONE_DRY () { return 'dry' }
  static get ZONE_CAB () { return 'cab' }

  static get icon () {
    return 'utensils'
  }

  /**
   * Fetch customer relations for this product
   *
   * @return promise
   */
  fetchCustomersRelations () {
    return this._mapper()
      .datastore
      .getMapper('Product')
      .fetchCustomersRelations({
        id: this.id
      })
  }

  /**
   * Update the customers array for this product
   *
   * @param array customers - Array of customer relation objects
   */
  updateCustomers (customers) {
    this.customers = []

    customers.forEach(customerRelation => {
      const customer = this._mapper()
        .datastore
        .getMapper('Customer')
        .createRecord(customerRelation.customer)

      this.customers.push(customer)
    })
  }

  /**
   * Link a customer to this product
   *
   * @param int customerId
   * @return promise
   */
  linkCustomer (customerId) {
    return this._mapper()
      .datastore
      .getMapper('Product')
      .linkCustomer({
        id: this.id,
        data: {
          customer_id: customerId,
          product_id: this.id
        }
      })
  }

  /**
   * Unlink a customer from this product
   *
   * @param int customerId
   * @return promise
   */
  unlinkCustomer (customerId) {
    return this._mapper()
      .datastore
      .getMapper('Product')
      .unlinkCustomer({
        customer_id: customerId,
        id: this.id
      })
  }
}

// Actions allow us to define additional calls we can make to related
// endpoints.
const actions = {
  fetchCustomersRelations: {
    method: 'GET',
    getEndpoint: function (BaseMapper, options) {
      const basePath = BaseMapper.getAdapter(BaseMapper.defaultAdapter).basePath
      const endpoint = BaseMapper.endpoint
      return `${basePath}/${endpoint}/${options.id}/customer?expand=customer`
    },
    response (response) {
      return response.data
    }
  },
  linkCustomer: {
    method: 'POST',
    getEndpoint: function (BaseMapper, options) {
      const basePath = BaseMapper.getAdapter(BaseMapper.defaultAdapter).basePath
      const endpoint = BaseMapper.endpoint
      return `${basePath}/${endpoint}/${options.id}/customer`
    },
    response (response) {
      return response.data
    }
  },
  unlinkCustomer: {
    method: 'DELETE',
    getEndpoint: function (BaseMapper, options) {
      const basePath = BaseMapper.getAdapter(BaseMapper.defaultAdapter).basePath
      const endpoint = BaseMapper.endpoint
      return `${basePath}/${endpoint}/${options.id}/customer/${options.customer_id}`
    },
    response (response) {
      return response.data
    }
  }
}

export default ProductRecord
export { actions }
